"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEGAL_FORMS = void 0;
/**
 * Legal forms (categories)
 */
exports.LEGAL_FORMS = {
    AARPI: 'AARPI',
    EARL: 'EARL',
    EI: 'EI',
    EURL: 'EURL',
    G_AGRI: 'G_AGRI',
    GAEC: 'GAEC',
    OTHER: 'OTHER',
    SA: 'SA',
    SARL: 'SARL',
    SAS: 'SAS',
    SASU: 'SASU',
    SC: 'SC',
    SCI: 'SCI',
    SCM: 'SCM',
    SCP: 'SCP',
    SE: 'SE',
    SELARL: 'SELARL',
    SNC: 'SNC',
    SPFPL: 'SPFPL',
};
